import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';
import Item from '../ui/Item';
import coca from '../../img/coca.png';
import pepsi from '../../img/pepsi.png';
import zero from '../../img/zero.png';
import hype from '../../img/hype.png';
import sprite from '../../img/sprite.png';
const dummy_data = [
    {
        key:'d1',
        name:'Coca',
        price:10000,
        icon:coca,

    },
    {
        key:'d2',
        name:'Pepsi',
        price:11000,
icon:pepsi,
    },
    {
        key:'d3',
        name:'Zero',
        price:11000,
        icon:zero,

    },
    {
        key:'d4',
        name:'Hype',
        price:25000,
icon:hype,

    },
    {
        key:'d5',
        name:' Sprite',
        price:11000,
icon:sprite,

    },

] ;


const Colas = (props) => {

    const drinksList = dummy_data.map((cola) => (
 
    <Item
      key={cola.id}
      name={cola.name}
      price={cola.price}
      icon = {cola.icon}
    />
  ));
   
  return (
<Fragment>
    <Closebutton onClick={props.onClick}/>
<Card>

{drinksList}

   </Card>
   </Fragment>
   )
}


export default Colas;